import createIcon from '../../createIcon';

/**
 * @component @name Sell
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDA4IDExLjQxMjlMMTIuNTc4IDIuNTgyOTNDMTIuMjA4IDIuMjEyOTMgMTEuNjk4IDIuMDAyOTMgMTEuMTY4IDIuMDAyOTNIMy45OTgwNUMyLjg5ODA1IDIuMDAyOTMgMS45OTgwNSAyLjkwMjkzIDEuOTk4MDUgNC4wMDI5M1YxMS4xNzI5QzEuOTk4MDUgMTEuNzAyOSAyLjIwODA1IDEyLjIxMjkgMi41ODgwNSAxMi41ODI5TDExLjQxOCAyMS40MTI5QzEyLjE5OCAyMi4xOTI5IDEzLjQ2OCAyMi4xOTI5IDE0LjI0OCAyMS40MTI5TDIxLjQxOCAxNC4yNDI5QzIyLjE5OCAxMy40NjI5IDIyLjE5OCAxMi4yMDI5IDIxLjQwOCAxMS40MTI5Wk02LjQ5ODA1IDguMDAyOTNDNS42NjgwNSA4LjAwMjkzIDQuOTk4MDUgNy4zMzI5MyA0Ljk5ODA1IDYuNTAyOTNDNC45OTgwNSA1LjY3MjkzIDUuNjY4MDUgNS4wMDI5MyA2LjQ5ODA1IDUuMDAyOTNDNy4zMjgwNSA1LjAwMjkzIDcuOTk4MDUgNS42NzI5MyA3Ljk5ODA1IDYuNTAyOTNDNy45OTgwNSA3LjMzMjkzIDcuMzI4MDUgOC4wMDI5MyA2LjQ5ODA1IDguMDAyOTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sell = createIcon('Sell', [
  [
    'path',
    {
      d: 'M21.408 11.4129L12.578 2.58293C12.208 2.21293 11.698 2.00293 11.168 2.00293H3.99805C2.89805 2.00293 1.99805 2.90293 1.99805 4.00293V11.1729C1.99805 11.7029 2.20805 12.2129 2.58805 12.5829L11.418 21.4129C12.198 22.1929 13.468 22.1929 14.248 21.4129L21.418 14.2429C22.198 13.4629 22.198 12.2029 21.408 11.4129ZM6.49805 8.00293C5.66805 8.00293 4.99805 7.33293 4.99805 6.50293C4.99805 5.67293 5.66805 5.00293 6.49805 5.00293C7.32805 5.00293 7.99805 5.67293 7.99805 6.50293C7.99805 7.33293 7.32805 8.00293 6.49805 8.00293Z',
      key: '1bgwr6',
    },
  ],
]);

export default Sell;
